<template>
    <a
        :href="metadata.metadataUrl"
        target="_blank"
        class="is-flex is-vcentered columns"
        style="margin:0; color: #088"
    >
    {{ metadata.name }}
    </a>
</template>

<script>
export default {
    name: "MetadataLink",
    props: {
        metadata: Object,
    }
}
</script>
